import $ from 'jquery';

const source = '.page-right';
const destination = '.page-bottom .layout';
const selectors = '.appearing-nav .links li a, .profile-posts .node-header a';
const subtype = {
  selector: 'pt321',
  label: 'California Teacher',
  href: '/cft-united',
};

export default class Explore {
  constructor() {
    this.$source = $(source);
    this.$destination = $(destination);
    this.buildLinks();
  }

  buildLinks() {
    const $list = $('<ul class="explore links"></ul>');

    this.$source.find(selectors).each((i, element) => {
      const item = `<li><a href="${$(element).attr('href')}">${$(element).text()}</a></li>`;
      $list.append(item);
    });

    // California Article Subtype Special Sauce
    // @see https://support.digitaldeployment.com/a/tickets/16160
    if (document.body.classList.contains(subtype.selector)) {
      const specialItem = `<li><a href="${subtype.href}">${subtype.label}</a></li>`;
      $list.prepend(specialItem);
    }

    this.$destination.prepend($list);
  }
}
